import { GOOGLE_SEARCH_URL } from '../contstants/googleMaps';

export const searchInGoogle = (data) => {
	const googleMapsLink = `${GOOGLE_SEARCH_URL}?q=${data}`;

	window.open(googleMapsLink, '_blank').focus();
};
